import React, { useRef, useState, useEffect, memo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import './index.less';
import AliOssUpload from '../AliOssUpload';
import queryDomMethods from '@/utils/queryDomMethods';
// import { recoverBodyScroll, stopBodyScroll } from '@/utils';

interface IProps {
    visible: boolean;
    url: string;
    onChange?: (url: string) => void;
}
const PictureCrop = (props: IProps) => {
    const aliOssUpload = useRef<AliOssUpload>();
    const cropper = useRef<Cropper>();
    const operationContaier = useRef<HTMLDivElement>(null);
    const [pictureUrl, setPictureUrl] = useState('');
    const [loading, setLoading] = useState(false);

    const handleEnlarge = () => cropper.current?.zoom(0.1);

    const handleNarrow = () => cropper.current?.zoom(-0.1);

    const initAliUpload = () => {
        if (!aliOssUpload.current) {
            aliOssUpload.current = new AliOssUpload({
                container: 'question-student-gdtk-container',
                dir: 'new-gdtk-img',
                multi_selection: false,
                filenameType: 'random_name',
            });
        }
    };

    const handleTurnLeft = () => {
        cropper.current?.rotate(-90);
        cropper.current?.zoomTo(0);
    };

    const handleTurnRight = () => {
        cropper.current?.rotate(90);
        cropper.current?.zoomTo(0);
    };

    const handleSure = async () => {
        if (loading) return;
        setLoading(true);
        cropper.current?.crop();
        // const base64 = cropper.current?.getCroppedCanvas().toDataURL('image/png');
        // console.log('base', base64)

        // const ret: any =  await aliOssUpload.current?.uploadBase64(base64!);
        // console.log('3333', ret);

        // cropper.current?.getCroppedCanvas().toBlob(
        //     async (blob: any) => {
        //         if (!blob) return;
        //         const file = new File([blob], 'image.png', { type: 'image/png' });
        //         const ret: any = await aliOssUpload.current?.uploadFileObj(file);
        //         console.log('retttt', ret);
        //         handleReset();
        //         props.onChange?.(ret[0]);
        //         setLoading(false);
        //     },
        //     'image/jpg',
        //     0.7
        // );
        cropper.current?.getCroppedCanvas().toBlob(
            async (blob: Blob | null) => {
                if (!blob) {
                    setLoading(false);
                    return;
                }

                const file = new File([blob], 'image.png', { type: 'image/png' });
                try {
                    const result: any = await aliOssUpload.current?.uploadFileObj(file);
                    console.log('🚀 ~ result:', result);
                    if (result?.[0]) {
                        props.onChange?.(result[0]);
                    }
                } catch (error) {
                    console.error('Upload failed:', error);
                } finally {
                    setLoading(false);
                    handleReset();
                }
            },
            'image/jpeg',
            0.7
        );
    };

    const handleReset = () => {
        if (loading) return;
        cropper.current?.clear();
        setPictureUrl('');
    };

    useEffect(() => {
        if (!pictureUrl) return;
        if (cropper.current) {
            cropper.current.replace(pictureUrl);
        } else {
            const image =
                queryDomMethods.querySelector('.picture-crop__picture') || (document.querySelector('.picture-crop__picture') as any);
            cropper.current = new Cropper(image, {
                viewMode: 1,
                minCropBoxWidth: 50,
                minCropBoxHeight: 50,
                autoCropArea: 0.96,
                cropBoxMovable: false,
            });
        }
    }, [pictureUrl]);

    useEffect(() => {
        setPictureUrl(props.url);
    }, [props.url]);

    useEffect(() => {
        const div = document.createElement('div');
        div.innerHTML = `
          <div id="question-student-gdtk-container" style="display: none;">
              <div id="selectfiles"></div>
              <div id="postfiles"></div>
          </div>
        `;
        document.body.appendChild(div);
        setTimeout(() => {
            initAliUpload();
        }, 100);

        return () => {
            cropper.current?.destroy();
            cropper.current = undefined;
        };
    }, []);

    // useEffect(() => {
    //     pictureUrl ? stopBodyScroll() : recoverBodyScroll();
    // }, [pictureUrl]);

    return props.visible ? (
        <div className="picture-crop-overlay" style={{ display: pictureUrl === '' ? 'none' : 'block' }}>
            <div className="picture-crop__operation-container" ref={operationContaier}>
                <div className="picture-crop__title">请拖动裁剪框来选择本题的答案区域，双击图片可移动裁剪框位置哦</div>
                <div className="picture-crop__picture-container">
                    <img className="picture-crop__picture" src={pictureUrl} />
                </div>
                <div className="picture-crop__operations">
                    <div className="picture-crop__enlarge" onClick={handleEnlarge}></div>
                    <div className="picture-crop__narrow" onClick={handleNarrow}></div>
                    <div className="picture-crop__turn-left" onClick={handleTurnLeft}></div>
                    <div className="picture-crop__turn-right" onClick={handleTurnRight}></div>
                    <div className="picture-crop__line"></div>
                    <div className="picture-crop__cancel" onClick={handleReset}>
                        取消
                    </div>
                    <div className="picture-crop__sure" onClick={handleSure}>
                        {loading ? <LoadingOutlined /> : '确定'}
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export default memo(PictureCrop);
